import { SOCIALS } from "@/lib/socials";

const FacebookIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="currentColor"
        aria-hidden
    >
        <path d="M13.5 21v-7.5h2.55l.38-2.97h-2.93V8.63c0-.86.24-1.45 1.47-1.45h1.57V4.52a20.7 20.7 0 0 0-2.29-.12c-2.27 0-3.82 1.38-3.82 3.92v2.19H7.85v2.97h2.58V21h3.07Z" />
    </svg>
);

const InstagramIcon = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden
    >
        <rect
            x="3"
            y="3"
            width="18"
            height="18"
            rx="5"
            stroke="currentColor"
            strokeWidth="1.6"
        />
        <circle cx="12" cy="12" r="3.8" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="17.4" cy="6.6" r="1" fill="currentColor" />
    </svg>
);

const ICONS = {
    facebook: <FacebookIcon />,
    instagram: <InstagramIcon />,
};

/**
 * Renders the site's social links as small circular icon buttons.
 * Style matches the rest of the site: sand background, ink icon, clay on hover.
 */
export default function SocialLinks({ testIdPrefix = "social", className = "" }) {
    return (
        <ul className={`flex items-center gap-3 ${className}`}>
            {SOCIALS.map((s) => (
                <li key={s.key}>
                    <a
                        href={s.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={s.label}
                        data-testid={`${testIdPrefix}-${s.key}`}
                        className="inline-flex w-10 h-10 items-center justify-center rounded-full border border-[var(--hds-line)] bg-[var(--hds-sand)] text-[var(--hds-ink)] hover:bg-[var(--hds-clay)] hover:text-[var(--hds-card)] hover:border-[var(--hds-clay)] transition-colors duration-300"
                    >
                        {ICONS[s.key]}
                    </a>
                </li>
            ))}
        </ul>
    );
}
